"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backgroundImageFormats = exports.backgroundImageWidths = void 0;
exports.backgroundImageWidths = Object.freeze([1024, 1366, 1600, 1920]);
exports.backgroundImageFormats = Object.freeze({
    webp: function (s) { return s.webp(); },
    jpeg: function (s) { return s.jpeg(); },
});
